
















































import { Mixins, Component } from "vue-property-decorator";
import { DialogMixin } from "../../../../../../../base/components/system/mixins";
import { DomainRegistry } from "../../../../../../domain";
import { QuestionnaireVariableFhirPathItem } from "../../../../../../domain/questionnaire";
import { CommonComponentsContainer } from "../../";
import { QuestionnaireVariableFhirPathItemSelector } from "../selectors";

@Component({
  components: {
    QuestionnaireVariableFhirPathItemSelector,
  }
})
export default class QuestionnaireVariableFhirPathItemSelectDialog extends Mixins(DialogMixin) {
  commonComponents: CommonComponentsContainer = null;
  confirmed = false;
  items: QuestionnaireVariableFhirPathItem[] = null;
  selectedItem: QuestionnaireVariableFhirPathItem = null;
  nameFilterText = "";
  expressionFilterText = "";

  get selectableItems(): QuestionnaireVariableFhirPathItem[] {
    return (this.isVisible && this.items)
      ? this.items.filter(i => this.includesFilter(this.nameFilterText, i.name) && this.includesFilter(this.expressionFilterText, i.expression))
      : [];
  }

  private includesFilter(filter: string, property: string): boolean {
    return filter.toLowerCase().split(/\s/).filter(v => v !== "").every(v => property.toLowerCase().includes(v));
  }

  get isLoading(): boolean {
    return !this.items;
  }

  get isSelected(): boolean {
    return !!this.selectedItem;
  }

  get selectedName(): string {
    return this.isSelected
      ? this.selectedItem.name
      : "";
  }

  get selectedExpression(): string {
    return this.isSelected
      ? this.selectedItem.expression
      : "";
  }

  async show(commonComponents: CommonComponentsContainer): Promise<QuestionnaireVariableFhirPathItem> {
    return this.showModal(async () => {
      this.commonComponents = commonComponents;
      await this.loadItems();
      await this.waitHidden();
      const confirmed = this.confirmed;
      const selectedItem = this.selectedItem;
      this.clear();
      return confirmed
        ? selectedItem
        : null;
    });
  }

  async loadItems() {
    this.items = null;
    const items = await DomainRegistry.instance.questionnaire.getVariableRepository().getFhirPath();
    this.items = items
      ? items.sort((a, b) => a.name.localeCompare(b.name))
      : [];
  }

  private clear() {
    this.confirmed = false;
    this.items = null;
    this.selectedItem = null;
    this.nameFilterText = "";
    this.expressionFilterText = "";
  }

  async addItem() {
    if (await this.commonComponents.getDialogs().getQuestionnaireVariableFhirPathItemEditDialog().show(false, this.items, this.selectedName, this.selectedExpression)) {
      this.selectedItem = null;
      await this.loadItems();
    }
  }

  async editItem() {
    if (await this.commonComponents.getDialogs().getQuestionnaireVariableFhirPathItemEditDialog().show(true, this.items, this.selectedName, this.selectedExpression)) {
      this.selectedItem = null;
      await this.loadItems();
    }
  }

  rowClick(value: QuestionnaireVariableFhirPathItem) {
    this.selectedItem = value;
  }

  confirm() {
    this.confirmed = true;
    this.isVisible = false;
  }

  cancel() {
    this.isVisible = false;
  }
}
